<template>
    <div class="recent-table">
        <el-table
            height="200"
            class="recent-news-table"
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column
                prop="subject"
                :label="$translate('lang.E3202103170001', { defaultText: '主题' })">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.subject" placement="top-start">
                        <span>{{scope.row.subject}}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column
                :show-overflow-tooltip="true"
                prop="link"
                :label="$translate('lang.E3202103170004', { defaultText: '动态链接' })">
                <template slot-scope="scope">
                    {{scope.row.link=='javascript:void(0);'?'':scope.row.link}}
                </template>
                </el-table-column>
            <el-table-column
                :label="$translate('lang.E3202103170002', { defaultText: '状态' })">
                <template slot-scope="scope">
                    <span :style="{color:scope.row.state===0?'':'red'}">
                        {{scope.row.state===0?$translate('lang.E3202103170020', { defaultText: '已启用' }):$translate('lang.E3202103170021', { defaultText: '已停用' })}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                prop="createUserCode"
                :label="$translate('lang.E3202102250026', { defaultText: '创建人' })">
            </el-table-column>
            <el-table-column
                sortable
                prop="pushTime"
                :label="$translate('lang.E3202110210001', { defaultText: '发布时间' })">
            </el-table-column>
            <el-table-column :label="$translate('lang.E3202101250007', { defaultText: '操作' })" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" @click="indexState(scope.row)">
                        {{scope.row.state=='0'?$translate('lang.E3202102260003', { defaultText: '停用' }):$translate('lang.E3202102260004', { defaultText: '启用' })}}
                    </el-button>
                    <el-button type="text" @click="changeNews(scope.row)">
                        {{$translate('lang.E3202102260009', { defaultText: '编辑' })}}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
export default {
    props: {
        tableData: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    methods: {
        indexState(row) {
            this.$emit('changeStauts', row);
        },
        changeNews(row) {
            this.$emit('changeNews', row);
        }
    }
};
</script>
<style lang="less">
.recent-table{
     .el-table--border {
        border: 1px solid #EBEEF5;
    }
}
</style>